
<template>
    <span
        :class="['form-input', (isSelected || inputVal !== '') && 'is-on-top']"
    >
        <label class="label" :for="id"><slot></slot></label>
        <textarea
            v-if="type === 'textarea'"
            :id="id"
            @focus="isSelected = true"
            @blur="isSelected = false"
            :name="name"
            v-model="inputVal"
            class="area"
            rows="5"
        >
        </textarea>
        <input
            v-else
            :id="id"
            :type="type"
            :name="name"
            @focus="isSelected = true"
            @blur="isSelected = false"
            v-model="inputVal"
            class="area"
        />
    </span>
</template>
<script>
export default {
    name: 'form-input',
    props: {
        isLarge: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
        },
        value: {
            type: String,
        },
        type: {
            type: String,
            default: 'text',
            validator(type) {
                return ['text', 'textarea', 'date', 'email'].indexOf(type) > -1
            }
        }
    },
    data() {
        return {
            id: Math.round(Math.random() * 0xFFFFFFFF).toString(16),
            isSelected: false,
            inputVal: this.value
        }
    },
    watch: {
        inputVal(value) {
            this.$emit('input', value)
        }
    },
    created() {

    },
    methods: {
        setFocus() {
            this.$el.querySelector('.area').focus()
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
.form-input
    display: inline-block
    position: relative
    font-size: 22px
    color: #646873
    border-bottom: 1px solid #767e88
    @include media-breakpoint-down($xl)
        font-size: 16px
    @include media-breakpoint-down($md)
        display: block
    // @include media-breakpoint-down($sm)
    //     font-size: 17px
.label
    position: absolute
    top: 0
    left: 0
    font-weight: 500
    transform-origin: top left
    transition: transform 0.5s, opacity 0.5s
    pointer-events: none
    .is-on-top &
        transform: translateY(-100%) scale(0.8)
        opacity: 0.5
.area
    margin-bottom: 25px
    height: auto
    width: 100%
    line-height: 1.25em
    opacity: 0
    @include media-breakpoint-down($xl)
        margin-bottom: 18px
    .is-on-top &
        opacity: 1
</style>
